import clsx from "clsx";
import { X } from "lucide-react";
import { getAlertColor } from "./getAlertColor";
import type { AlertProps } from "./types";

export default function Alert({
  variant = "info",
  message,
  hasCloseButton,
  dismissAlert,
  className,
}: AlertProps) {
  let pr = "pr-2";

  if (hasCloseButton) {
    pr = "pr-10";
  }

  const alertColor = getAlertColor(variant);

  return (
    <div
      className={clsx(
        className,
        `border bg-${alertColor}-100 border-${alertColor}-400 text-${alertColor}-700 py-2 pl-2 ${pr} rounded relative text-sm`
      )}
      role="alert"
    >
      {message}

      {hasCloseButton && (
        <button
          className="absolute top-1/2 -translate-y-1/2 right-0 w-10 h-10 flex items-center justify-center"
          onClick={dismissAlert}
        >
          <X />
        </button>
      )}
    </div>
  );
}
